/**
 * Created by mariushirjanu on 22/02/2021.
 */
import { Component, OnInit } from '@angular/core';
import { IFileUploadFailResponse, IFileUpload, IFileUploadResponse, ResponseStatus } from '../../file-upload/file-upload.service';
import { GaMessageService } from '../../message/ga-message.service';
import { TranslationService } from '../../translation/translation.service';
import { ExtraFieldType } from '../extra-field-type';
import { FormlyType } from '../ga-formly.service';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-upload-button',
  template: `
    <file-button 
      [class]="classNames"
      [ngClass]="to.fileUploadButtonClass || 'btn-primary'"
      [url]="to.url" 
      [formData]="to.uploadContext" 
      [submitting]="to.busy" 
      [uploading]="to.uploading"
      (onAfterSubmit)="onAfterSubmit($event)" 
      (onFileAdd)="onFileAdd($event)" 
      (onUploadStarted)="onUploadStarted()" 
      (onUploadProgress)="onUploadProgress($event)" 
      (onUploadDone)="onUploadDone($event)" 
      (onUploadFailed)="onUploadFailed($event)"
    >
      <span translate><i [ngClass]="to.icon" *ngIf="to.icon"></i> {{to.label}}</span>
    </file-button>
    <span class="file-upload-name" *ngIf="!to.hdeFilename">{{filename}}</span>
    <input type="hidden" [formControl]="formControl" [formlyAttributes]="field" />
  `
})
export class FormlyFieldFileUploadComponent extends ExtraFieldType implements OnInit {
  public progress:number;
  public filename:string;

  private abortFn:Function;
  private uploadingStatusMessage:Noty;
  private uploadFailedMessage:Noty;

  constructor(
    private formlyUtil:GaFormlyUtil,
    private gaMessageService:GaMessageService,
    private translationService:TranslationService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.FILE_UPLOAD, <string>this.key, this.to.label);

    this.listen();
  }

  protected listen(): void {
    if (this.to.startUpload) {
      this.to.startUpload.subscribe((uploadFormData: any) => {
        this.to.uploadContext = uploadFormData;

        // start upload
        this.to.busy = true;
        this.to.uploading = true;
      });
    }
  }

  public onFileAdd(file:File):void {
    this.filename = file.name;
    this.formControl.patchValue(file);

    if (this.to.onChange) {
      this.to.onChange(file);
    }

    if (this.to.autoUpload) {
      this.to.busy = true;
      this.to.uploading = true;
    }
  }

  public onAfterSubmit(submitHandler:XMLHttpRequest):void {
    this.abortFn = submitHandler.abort;
    this.to.busy = false;
  }

  public onUploadStarted():void {
    this.gaMessageService.closeMessage(this.uploadFailedMessage); // close any previous failed message
    this.uploadingStatusMessage = this.gaMessageService.showStatusMessage(this.translationService.instant('GA.FORM.UPLOAD.UPLOADING', { label: this.filename }));
  }

  public onUploadProgress(progress:number):void {
    this.progress = progress;
  }

  public onUploadDone(result:IFileUpload):void {
    this.to.uploading = false;
    this.gaMessageService.closeMessage(this.uploadingStatusMessage);
    this.gaMessageService.showFeedbackMessage('GA.FORM.UPLOAD.UPLOAD_OK');

    if (this.to.onUploadDone) {
      this.to.onUploadDone(result?.response?.data);
    }
  }

  public onUploadFailed(response:IFileUploadFailResponse):void {
    this.uploadFailed(response);
  }

  private uploadFailed(response?:IFileUploadFailResponse | IFileUploadResponse):void {
    this.gaMessageService.closeMessage(this.uploadingStatusMessage);
    this.to.uploading = false;

    let errorMessage:string = this.translationService.instant('GA.FORM.UPLOAD.UPLOAD_FAIL');

    if (response) {
      if (response?.status === ResponseStatus.FAIL) {
        // exception returned by server
        errorMessage += `: ${response.message}`;
      } else if (response.status) {
        // internel server error detected by JQueryFileUpload
        errorMessage += `: ${this.filename} (${response.status}${(<IFileUploadFailResponse>response).error? ' ' + (<IFileUploadFailResponse>response).error : ''})`;
      }
    }

    this.uploadFailedMessage = this.gaMessageService.showErrorMessage(errorMessage);

    if (this.to.onUploadFailed) {
      this.to.onUploadFailed(errorMessage);
    }
  }
}